'use strict';

import ready from './lib/ready';
import {mutate} from './lib/promise-fastdom';
import promiseIdle from './lib/promise-idle';
import ToggleArea from './lib/ToggleArea';
import nodeFromTemplate from './lib/node-from-template';
import ModalBehavior from './lib/ToggleArea_ModalBehavior';

ready()
	.then(promiseIdle())
	.then(mutate(function () {

		const landmark = nodeFromTemplate('nav-landmark');
		const toggle = nodeFromTemplate('nav-toggle');
		const close = nodeFromTemplate('nav-close');
		const area = document.querySelector('.nav');

		Promise.resolve()
			.then(mutate(() => {
				toggle.appendChild(nodeFromTemplate('nav-button-icon'));
				close.appendChild(nodeFromTemplate('nav-button-icon'));
				landmark.appendChild(toggle);
				area.appendChild(close);
				document.querySelector('.header__inner').appendChild(landmark);
			}))
			.then(() => (new ToggleArea(area, 'nav', [
				new ModalBehavior(toggle, close)
			])));
	}));
